export const getDraftPreflight = (draft) => draft.preflight;
